<div class="p-flex-col-sm p-p-sm">
  <div class="p-flex p-flex-between p-flex-center-y">
    <span class="p-text-body p-color-text-secondary">History</span>
    @if (isPending || isLoading) {
    <p-progress-spinner size="medium" />
    }
  </div>

  <div class="p-flex-col-xxs p-flex-grow-1">
    @for (xform of transforms; track xform.id; let i = $index) {
    <div
      class="p-flex p-flex-between p-flex-center-y p-w-full p-p-xxs p-text-footnote p-color-text-tertiary history-item"
      [ngClass]="{selected: xform.id === activeTransform?.id, disabled: !editable() }"
      (click)="editTransform(xform)"
    >
      {{ describeTransform(xform) }}
      @if (editable()) {
      <p-button-icon-ghosted-sm icon="delete" (click)="deleteTransform($event, xform)" />
      }
    </div>
    }
  </div>
</div>
